import { io } from 'socket.io-client';
import { HTTP_ENDPOINTS } from "./clients.constants";

class SocketClient {
  static instance = null;

  constructor() {
    if (SocketClient.instance) {
      return SocketClient.instance;
    }

    this.socket = io(HTTP_ENDPOINTS.SOCKET_URL, { withCredentials: true });
    SocketClient.instance = this;

    this.socket.on('connect', () => {
      console.log(`Connected to WebSocket with ID: ${this.socket.id}`);
    });

    this.socket.on('disconnect', () => {
      console.log('Disconnected from WebSocket');
    });
  }

  getSocket() {
    return this.socket;
  }
}

const socketClient = new SocketClient();
export default socketClient;